import { render } from "./AddComp.vue?vue&type=template&id=1396cb85"
import script from "./AddComp.vue?vue&type=script&lang=js"
export * from "./AddComp.vue?vue&type=script&lang=js"

import "./AddComp.vue?vue&type=style&index=0&id=1396cb85&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__